import { render } from 'preact';
import { App } from './app';
import './styles.css';
import './library.css';
import './brand.css';
import './fixes.css';
import './fix-home.css';
import './fix-send.css';
import './fix-account.css';

render(<App />, document.getElementById('app')!);
